export default __webpack_public_path__ + "static/media/artistProfile.3238d394.png";